import {Component, OnDestroy, OnInit} from '@angular/core';

import {Chart} from 'chart.js';
import * as annotation from 'chartjs-plugin-annotation';

import {DataService} from '../Services/data.service';
import {PersonLunch} from '../Model/PersonLunch';
import Timer = NodeJS.Timer;

@Component({
  selector: 'app-live',
  templateUrl: './live.component.html',
  styleUrls: ['./live.component.css']
})

export class LiveComponent implements OnInit, OnDestroy {

  timeLine = ["12:00", "12:05", "12:10", "12:15", "12:20", "12:25", "12:30", "12:35", "12:40", "12:45", "12:50", "12:55", "13:00"];
  expectedLunch = [];
  definitiveLunch = [];
  chart;

  live;
  lunchDone;
  beforeLunch;

  today;
  updating;
  lunchRefreshInterval: Timer;

  constructor(private dataService: DataService) {
    Chart.pluginService.register(annotation);
    this.today = new Date();
    this.live = false;
    this.lunchDone = false;
    this.beforeLunch = false;

  }

  /**
   * check if time is before lunch, in lunch or after lunch
   */
  checkLunchStatus() {
    this.live = false;
    if(this.today.getHours() === 12) {
      this.live = true;
    } else if(this.today.getHours() > 12) {
      this.lunchDone = true;
    } else {
      this.beforeLunch = true;
    }
  }

  /**
   * Determine which lunch lines are active and how big the chart must be
   */
  determineLunch() {
    this.today = new Date();
    this.checkLunchStatus();
    this.dataService.getPersonLunchesLiveStatistics().then((response: PersonLunch[]) => {
      this.chart.options.scales.yAxes[0].ticks.max = response.length + 5;
      this.determineSubscribedLunches(response);
      if(this.live) {
        this.determineDefinitiveLunches(response);
      } else if(this.lunchDone) {
        this.determineDefinitiveLunchesWhenLunchIsOver(response)
      }
      this.updating = false;
    });
  }

  /**
   * determine how much subscribedlunches per 5 minutes
   * @param {PersonLunch[]} response
   */
  public determineSubscribedLunches(response: PersonLunch[]) {
    var that = this;
    that.expectedLunch = [];
    for(let i = 0; i<this.timeLine.length; i++) {
      that.expectedLunch.push(0);
    }
    console.log(response);
    console.log(this.expectedLunch);
    response.forEach(function (personLunch) {
      if(personLunch.lunch) {
        switch (personLunch.time) {
          case 1200:
            that.expectedLunch[0]++;
            break;
          case 1205:
            that.expectedLunch[1]++;
            break;
          case 1210:
            that.expectedLunch[2]++;
            break;
          case 1215:
            that.expectedLunch[3]++;
            break;
          case 1220:
            that.expectedLunch[4]++;
            break;
          case 1225:
            that.expectedLunch[5]++;
            break;
          case 1230:
            that.expectedLunch[6]++;
            break;
          case 1235:
            that.expectedLunch[7]++;
            break;
          case 1240:
            that.expectedLunch[8]++;
            break;
          case 1245:
            that.expectedLunch[9]++;
            break;
          case 1250:
            that.expectedLunch[10]++;
            break;
          case 1255:
            that.expectedLunch[11]++;
            break;
          case 1300:
            that.expectedLunch[12]++;
            break;
        }
      }
    });
    for (let i = 0; i < this.expectedLunch.length; i++) {
      if (i != 0) {
        this.expectedLunch[i] = this.expectedLunch[i] + this.expectedLunch[i - 1];
      }
    }
    this.chart.data.datasets[0].data = this.expectedLunch;
    this.chart.update();
  }

  /**
   * Determine Definitive lunches per 5 minutes until the current time is reached when lunch is active
   * @param {PersonLunch[]} response
   */
  public determineDefinitiveLunches(response: PersonLunch[]) {
    this.definitiveLunch = [];
    var that = this;

    if(that.today.getHours() >= 12) {
      console.log(that.today.getMinutes());
      let amountMinutes = that.today.getMinutes() / 5;
      console.log(amountMinutes);
      for(let i = 0; i<amountMinutes; i++) {
        that.definitiveLunch.push(0);
      }
    }

    response.forEach(function (personLunch) {

      let date = new Date(personLunch.didLunchTime);
      if(personLunch.didLunch) {
        var startMinute = 0;
        var endMinute = 5;

        for(let i = 0; i < that.definitiveLunch.length; i++) {
          if(date.getHours() == 12 && date.getMinutes() >= startMinute && date.getMinutes() < endMinute) {
            that.definitiveLunch[i]++;
            break;
          } else {
            startMinute = startMinute + 5;
            endMinute = endMinute + 5;
          }
        }
      }

    });
    for (let i = 0; i < this.definitiveLunch.length; i++) {
      if (i != 0) {
        this.definitiveLunch[i] = this.definitiveLunch[i] + this.definitiveLunch[i - 1];
      }
    }

    this.chart.data.datasets[1].data = this.definitiveLunch;
    this.chart.options.annotation.annotations[0].value = this.timeLine[this.definitiveLunch.length - 1];
    this.chart.update();
  }

  /**
   * Determine all lunches per 5 minutes for the whole hour when the lunch is over
   * @param {PersonLunch[]} response
   */
  public determineDefinitiveLunchesWhenLunchIsOver(response: PersonLunch[]) {
    var that = this;
    this.definitiveLunch = [];
    response.forEach(function (personLunch) {
      if(personLunch.didLunch) {
        let date = new Date(personLunch.didLunchTime);
        if(that.today.getHours() >= 13) {
          for(let i = 0; i<that.timeLine.length; i++) {
            that.definitiveLunch.push(0);
          }
        }

        var startMinute = 0;
        var endMinute = 5;

        for(let i = 0; i < that.definitiveLunch.length; i++) {
          if(date.getHours() == 12 && date.getMinutes() >= startMinute && date.getMinutes() < endMinute) {
            that.definitiveLunch[i]++;
            break;
          } else {
            startMinute = startMinute + 5;
            endMinute = endMinute + 5;
          }
        }
      }

    });
    for (let i = 0; i < this.definitiveLunch.length; i++) {
      if (i != 0) {
        this.definitiveLunch[i] = this.definitiveLunch[i] + this.definitiveLunch[i - 1];
      }
    }

    this.chart.data.datasets[1].data = this.definitiveLunch;
    this.chart.update();
    console.log(this.chart);
  }

  /**
   * on initializing the page check the PersonName
   */
  ngOnInit(): void {
    this.chart = new Chart('canvas', {
      type: 'line',
      data: {
        labels: this.timeLine,
        datasets: [{
          label: 'Aantal aangemelde lunchers',
          data: this.expectedLunch,
          backgroundColor: [
            'rgba(243, 91, 10, 0.2)',
          ],
          borderColor: [
            'rgba(243, 91, 10, 1)',
          ],
          borderWidth: 1,
          lineTension: 0,
        },
          {
            label: 'Aantal definitieve lunchers',
            data: this.definitiveLunch,
            backgroundColor: [
              'rgba(0, 123, 255, 0.2)'
            ],
            borderColor: [
              'rgba(0, 123, 255, 1)',
            ],
            borderWidth: 1,
            lineTension: 0,
          }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              callback: function (value) {
                if (value % 1 === 0) {
                  return value;
                }
              },
              max: 100
            }
          }]
        },
        annotation: {
          drawTime: "afterDraw",
          annotations: [
            {
              type: "line",
              mode: "vertical",
              scaleID: "x-axis-0",
              value: "0",
              borderColor: "red",
              label: {
                content: "NU",
                enabled: true,
                position: "top"
              }
            }
          ]
        }
      }
    });

    this.lunchRefreshInterval = setInterval(() => {
      this.updating = true;
      this.determineLunch();
    }, 30000);
    this.determineLunch();
  }

  /**
   * On leaving the page
   */
  ngOnDestroy(): void {
    console.log("Destroy interval");
    clearInterval(this.lunchRefreshInterval);
  }
}



// WEBPACK FOOTER //
// ./src/app/Live/live.component.ts